import { getCookie } from '../utils/cookiesUtils';

const FORCE_ANALYTICS_COOKIE = 'force_analytics';
const REAUID_COOKIE = 'reauid';

const forceAnalyticsCookieDefault = getCookie(FORCE_ANALYTICS_COOKIE);
const reauidCookieDefault = getCookie(REAUID_COOKIE);

const shouldTrackEvent = (
  tracking,
  forceAnalyticsCookie = forceAnalyticsCookieDefault,
  reauidCookie = reauidCookieDefault,
) => {
  if (!tracking) {
    return false;
  }

  const { percentage = 0 } = tracking;

  if (forceAnalyticsCookie === 'true') {
    return true;
  }
  if (forceAnalyticsCookie === 'false') {
    return false;
  }

  if (!reauidCookie) {
    return false;
  }

  const uidNumber = parseInt(reauidCookie, 16) || 0;
  return uidNumber >= 0 && uidNumber % 100 < percentage;
};

export default shouldTrackEvent;
